import React, { useContext } from "react";
import { RoomContext } from "../context";
import Title from "../components/Title";
import styled from "styled-components";

const FilterContainer = styled.section`
  padding: 5rem 0;
`;
const FilterForm = styled.form`
  width: 60vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(202px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 40px;
  @media screen and (min-width: 776px) {
    width: 70vw;
  }
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
  }
`;
const FormGroup = styled.div`
  text-transform: capitalize;
  label {
    display: block;
    letter-spacing: 3px;
    margin-bottom: 0.5rem;
  }
  input {
    width: 100%;
    background: transparent;
    font-size: 1rem;
  }
`;
const FormControl = styled.select`
  width: 100%;
  background: transparent;
  font-size: 1rem;
`;
const SizeInputs = styled.div`
  display: flex;
  input {
    width: 40%;
    padding: 0.2rem;
    border: 1px solid #222;
    border-radius: 0.3rem;
    margin-right: 0.3rem;
  }
`;
//get all unique values
const getUnique = (items, value) => {
  return [...new Set(items.map((item) => item[value]))];
};
export default function RoomFilter({ rooms }) {
  const context = useContext(RoomContext);
  const {
    handleChange,
    type,
    capacity,
    price,
    minPrice,
    maxPrice,
    minSize,
    maxSize,
    breakfast,
    pets,
  } = context;
  //get unique types
  let types = getUnique(rooms, "type");
  // add all
  types = ["all", ...types];
  //map onto JSX
  types = types.map((item, index) => {
    return (
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  let people = getUnique(rooms, "capacity");
  people = people.map((item, index) => {
    return (
      <option key={index} value={item}>
        {item}
      </option>
    );
  });
  return (
    <FilterContainer>
      <Title title="Search Rooms" />
      <FilterForm>
        <FormGroup>
          <label htmlFor="type">Room Type</label>
          <FormControl
            name="type"
            id="type"
            value={type}
            onChange={handleChange}
          >
            {types}
          </FormControl>
        </FormGroup>
        <FormGroup>
          <label htmlFor="capacity">Guests</label>
          <FormControl
            name="capacity"
            id="capacity"
            value={capacity}
            onChange={handleChange}
          >
            {people}
          </FormControl>
        </FormGroup>
        <FormGroup>
          <label htmlFor="price">Room Price ${price}</label>
          <input
            type="range"
            name="price"
            min={minPrice}
            max={maxPrice}
            id="price"
            value={price}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="size">Room Size</label>
          <SizeInputs>
            <input
              type="number"
              name="minSize"
              id="size"
              value={minSize}
              onChange={handleChange}
            />
            <input
              type="number"
              name="maxSize"
              id="size"
              value={maxSize}
              onChange={handleChange}
            />
          </SizeInputs>
        </FormGroup>
        <FormGroup>
          <div className="single-extra">
            <input
              type="checkbox"
              name="breakfast"
              id="breakfast"
              checked={breakfast}
              onChange={handleChange}
            />
            <label htmlFor="breakfast">Breakfast</label>
          </div>
          <div className="single-extra">
            <input
              type="checkbox"
              name="pets"
              id="pets"
              checked={pets}
              onChange={handleChange}
            />
            <label htmlFor="pets">Pets</label>
          </div>
        </FormGroup>
      </FilterForm>
    </FilterContainer>
  );
}
